import { render, staticRenderFns } from "./VersionBrowser.vue?vue&type=template&id=07893065&scoped=true&"
import script from "./VersionBrowser.vue?vue&type=script&lang=js&"
export * from "./VersionBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07893065",
  null
  
)

export default component.exports